import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.clubUser}/v4`, {
  get: {
    'get.history': '/importHistory',
    'get.history_detail': '/importHistory/:requestId/importedMembers',
    'get.import_limit': '/import/limit'
  },
  post: {
    'post.member': '/import/member',
    'import.hotmart': {
      path: '/import/hotmart?membershipClass=:membershipClass',
      options: {}
    },
    'import.csv': {
      options: {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      },
      path: '/import/members-csv'
    }
  }
});
